import { render, staticRenderFns } from "./otherSyncCount.vue?vue&type=template&id=4406ff0e&scoped=true"
import script from "./otherSyncCount.vue?vue&type=script&lang=js"
export * from "./otherSyncCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406ff0e",
  null
  
)

export default component.exports